import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { IDesign, ISurveyQuestion } from 'rebus-models';
import { toArray } from 'lodash';

@Component({
  selector: 'app-survey-unique',
  templateUrl: './survey-unique.component.html',
  styleUrls: ['./survey-unique.component.scss']
})
export class SurveyUniqueComponent implements OnInit {

  @Input() public design: IDesign;
  @Input() public idxSurvey: number;
  @Input() public totalSurveys: number;
  @Input() public answers: any;
  @Input() public question: ISurveyQuestion;
  @Input() public userHasRecord: boolean;
  @Input() public userAnswerSurvey: any;

  @Output() public sendAnswer: EventEmitter<any> = new EventEmitter();

  public answerUser: any;

  public ngOnInit() {
    const surveyAnswerUser = toArray(this.userAnswerSurvey)[0];
    if (surveyAnswerUser) {
      const answerUser = toArray(surveyAnswerUser.answers).filter(answer => answer.questionId === this.question.id);
      this.answerUser = answerUser[0].answerUser;
    }
  }


  public changeAnswerSelected(answerId) {
    this.sendAnswer.emit({
      question: this.question,
      questionId: this.question.id,
      answerUser: answerId,
      createdAt: new Date().getTime(),
    });
  }
}
